import React, { PropsWithChildren, ReactNode } from 'react';

import './ErrorBoundary.scss';

export type ErrorBoundaryProps = PropsWithChildren<{
  /** When set, shown instead of children after an error is caught. */
  fallback?: ReactNode;
}>;

type ErrorBoundaryState = { hasError: boolean };

const DefaultFallback = () => (
  <div role="alert" data-qa-id="error-boundary-fallback" className="hl-error-boundary-fallback">
    Something went wrong loading this content. You can try refreshing the page. If the problem continues, contact
    support.
  </div>
);

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error(error);
    console.error(errorInfo);
    console.error('stack:');
    console.error(error.stack);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback !== undefined ? this.props.fallback : <DefaultFallback />;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
